export default __webpack_public_path__ + "static/media/referrals.d62b1f2c.png";